<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>

		<!-- Sign Up Image And Headings -->
		<div class="sign-up-header" style="background-image: url('https://media.istockphoto.com/id/1325705911/vector/futuristic-geometric-golden-yellow-gradation-background-diagonal-line-vector-illustration.jpg?s=612x612&w=0&k=20&c=UyAKU3yhHMhQiSYDvIp1xOEV715LOxHjlnIgTDrYLVw=')">
			<div class="content">
				<h1 class="mb-5">Holaa</h1>
				<p class="text-lg">Crea tu cuenta y disfruta de lo que ofrecemos.</p>
			</div>
		</div>
		<!-- / Sign Up Image And Headings -->
		
		<!-- Sign Up Form -->
		<a-card :bordered="false" class="card-signup header-solid h-full" :bodyStyle="{paddingTop: 0}">
			<!--<template #title>
				<h5 class="font-semibold text-center">Registrate con </h5>
			</template>-->
			<!--<div class="sign-up-gateways">
    			
    			<a-button @click="handleSubmitGoogle">
					<img src="images/logos/Google__G__Logo.svg.png" alt="">
				</a-button>
			</div>
			<p class="text-center my-25 font-semibold text-muted">O</p>-->
			<p class="text-center my-25 font-semibold text-muted">Registro</p>
			<br>
			<a-form
				id="components-form-demo-normal-login"
				:form="form"
				class="login-form"
				@submit="handleSubmit"
			>
				<a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'name',
						{ rules: [{ required: isloginWithEmail, message: 'Campo requerido' }] },
						]"
						placeholder="Name"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'email',
						{ rules: [{ required: isloginWithEmail, message: 'Campo requerido' }] },
						]"
						placeholder="Email"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input
						v-decorator="[
						'password',
						{ rules: [{ required: isloginWithEmail, message: 'Campo requerido'  }] },
						]"
						type="password"
						placeholder="Password"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input
						v-decorator="[
						'phone',
						{ rules: [{ required: true, message: 'Campo requerido'  }] },
						]"
						type="text"
						placeholder="Número teléfonico"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input
						v-decorator="[
						'address',
						{ rules: [{ required: true, message: 'Campo requerido' }] },
						]"
						type="text"
						placeholder="Dirección"
					>
					</a-input>
				</a-form-item>
			
				<a-form-item>
					<a-button type="primary" block html-type="submit" class="login-form-button">
						REGISTRAR
					</a-button>
				</a-form-item>
			</a-form>
			<p class="font-semibold text-muted text-center">Ya tienes una cuenta? <router-link to="/sign-in" class="font-bold text-dark">Iniciar sesión</router-link></p>
		</a-card>
		<!-- / Sign Up Form -->

	</div>
</template>

<script>
import { loginGoogle,register } from '@/services/auth/auth';
	export default ({
		data() {
			return {
				isloginWithEmail:true
			}
		},
		beforeCreate() {
			// Creates the form and adds to it component's "form" property.
			this.form = this.$form.createForm(this, { name: 'normal_login' });
		},
		methods: {
			// Handles input validation after submission.
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if ( !err ) {
						
						register(values).then(()=>{
							 this.$router.push('/');
						})
					}
				});
			},
			handleSubmitGoogle(e) {
			this.isloginWithEmail = false;
				setTimeout(() => {
					e.preventDefault();
					this.form.validateFields((err, values) => {
					if (!err) {
						
						loginGoogle(values).then(()=>{
							 this.$router.push('/');
						})
					}
					});
				}, 1000);
			}

		},
	})

</script>

<style lang="scss">
</style>